import {createContext} from 'react';

export const Context = createContext({size: [0, 0], partiallyCovered: false});
